import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-tour-online-booking',
  templateUrl: environment.mobile ? './tour-online-booking.component.mobile.html' : './tour-online-booking.component.html',
  styleUrls: environment.mobile ? ['./tour-online-booking.component.mobile.scss'] : ['./tour-online-booking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class TourOnlineBookingComponent {}
